
import * as React from "react";
import { ElementImportEntry, ImportSettings } from "../model/ImportModel";
import Select from "./select/Select";
import { Utilities } from "shared/utilities";
import { Option } from "shared/model/Option";

export const ImportEntry: React.FC<ImportEntryProps> = (props) => {

    const onChangeImportOption = (e: Option) => {
        props.onChangeImportOptions(e, props?.setting?.uri.id);
    };

    const getWarningLabel = () => {
        let warning = "";
        if (!(props.entry.hasMissingEnvironmentVariables || props.entry.hasMissingSubprocess || props.entry.hasMissingTasks || props.entry.hasConflict)) {
            return null;
        }
        if (props.entry.hasMissingEnvironmentVariables) {
            warning += `Environment variables:${props.entry.missingEnvironmentVariables.join(", ")}\n`
        }
        if (props.entry.hasMissingSubprocess) {
            warning += `Subprocesses:${props.entry.missingSubProcesses.join(", ")}\n`
        }
        if (props.entry.hasMissingTasks) {
            warning += `Tasks:${props.entry.missingTaskPackages.join(", ")}\n`
        }
        if (props.entry.hasConflict) {
            warning += `${FRENDS.Localizations.ImportConflictWith} ${props.entry.maxVersion}\n`
        }
        return <span><i className="ci-warning_outline" title={warning}></i> {warning}</span>
    };
    return (
        <tr key={props.entry.uri.id}>
            <td>{props.entry.typeName}</td>
            <td>{props.entry.name}</td>
            <td className="wrap">{getWarningLabel()}</td>
            <td>
                <Select
                    className="conflict-option-selector"
                    classNamePrefix="react-select"
                    value={Utilities.valueFromId(props?.setting?.conflictOptionsList, props?.setting?.conflictOption)}
                    options={props?.setting?.conflictOptionsList}
                    placeholder={FRENDS.Localizations.Select}
                    onChange={onChangeImportOption}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                />
            </td>
        </tr>
    );
};

export interface ImportEntryProps {
    entry: ElementImportEntry;
    setting: ImportSettings | undefined;
    onChangeImportOptions: (option: Option, settingId: string | undefined) => void;
}
